import {
  BI_ENDPOINTS,
  BI_ORIGINS,
  LIST_LAYOUT,
  MembersModal,
  WIDGET_TYPE,
  getEventId,
  isEventDetailsPageHiddenInternal,
} from '@wix/wix-events-commons-statics'
import {AnyAction} from 'redux'
import {EventMap} from '../../../../commons/bi/interfaces'
import {MODAL_OPENED_OLD, openModal} from '../../../../commons/services/modal'
import {shareEvent} from '../actions/event'
import {widgetLoaded} from '../actions/layout'
import {navigateToPage, navigatedToPage, onLinkNavigatedToPage} from '../actions/navigate-to-page'
import {State} from '../types/state'

export const eventMap: EventMap = {
  [navigatedToPage.toString()]: (_state: State, action: ReturnType<typeof navigatedToPage>) => ({
    evid: 503,
    event_id: getEventId(action.payload.event),
    destination_type: !isEventDetailsPageHiddenInternal(action.payload.event) ? 'page_details' : 'page_form',
  }),
  [navigateToPage.fulfilled.toString()]: (_state: State, action: ReturnType<typeof navigateToPage.fulfilled>) => {
    if (action.payload) {
      return {
        evid: 503,
        event_id: getEventId(action.meta.arg.event),
        destination_type: !isEventDetailsPageHiddenInternal(action.meta.arg.event) ? 'page_details' : 'page_form',
      }
    }
  },
  [onLinkNavigatedToPage.toString()]: (_state: State, action: ReturnType<typeof onLinkNavigatedToPage>) => ({
    evid: 503,
    event_id: getEventId(action.payload.event),
    destination_type: !isEventDetailsPageHiddenInternal(action.payload.event) ? 'page_details' : 'page_form',
  }),
  [widgetLoaded.toString()]: (state: State, {isHomePage}) => {
    const {widgetType, listShowImage, showImage, listLayout} = state.component.settings
    const single = widgetType === WIDGET_TYPE.SINGLE
    const display_type = single ? 'SINGLE' : 'LIST'
    const has_image = single ? showImage : listShowImage
    const layout = single ? 'SINGLE' : getListLayoutName(listLayout)

    return {
      evid: 80,
      has_image,
      layout,
      is_main_page: isHomePage,
      display_type,
    }
  },
  [MODAL_OPENED_OLD]: (_state: State, action: AnyAction) => {
    if (action.modalType === MembersModal.LIST) {
      return {
        evid: 89,
        event_id: action.params.eventId,
      }
    }
  },
  [openModal.fulfilled.toString()]: (_state: State, action: Awaited<ReturnType<typeof openModal.fulfilled>>) => {
    if (action.meta.arg.type === MembersModal.LIST) {
      return {
        evid: 89,
        event_id: action.meta.arg.params.eventId,
      }
    }
  },
  [shareEvent.toString()]: (_state: State, action: ReturnType<typeof shareEvent>) => ({
    evid: 513,
    event_id: action.payload.eventId,
    button_name: action.payload.buttonName,
    origin: BI_ORIGINS.WIDGET,
  }),
  endpoint: BI_ENDPOINTS.EVENTS_UOU,
}

const getListLayoutName = (listLayout = LIST_LAYOUT.NEW_GRID) => {
  return Object.entries(LIST_LAYOUT)
    .find(([, value]) => value === listLayout)
    .shift()
}
